import { z } from 'zod';

import { ISSUE_LINK_TYPE } from '../enums';

export const createLinkInputSchema = z.object({
  targetIssueId: z.string().min(1),
  linkType: z.enum([
    ISSUE_LINK_TYPE.BLOCKS,
    ISSUE_LINK_TYPE.IS_BLOCKED_BY,
    ISSUE_LINK_TYPE.RELATES_TO,
    ISSUE_LINK_TYPE.DUPLICATES,
    ISSUE_LINK_TYPE.DUPLICATED_BY,
  ]),
});
export type CreateLinkInput = z.infer<typeof createLinkInputSchema>;
